/* eslint-disable comma-dangle */

export default {
    styleguide: () => import(
        /* webpackChunkName: 'vue-components/styleguide' */
        'framework/styleguide/page/index.vue'
    ),
    sample: () => import(
        /* webpackPrefetch: true */
        /* webpackChunkName: 'vue-components/sample' */
        'framework/components/page-templates/sample/sample.vue'
    ),
};
